import { useState, useEffect } from 'react'
import MediaNote from './MediaNote'
import MediaRecommendations from './MediaRecommendations'

/**
 * Meta component that wraps MediaNote and MediaRecommendations
 * with a subtle divider at the top and margin at the bottom
 *
 * @param {string} mediaType - The type of media (song, album, playlist, mix, collage)
 * @param {number} mediaId - The ID of the media object
 */
function UserMetadata({ mediaType, mediaId }) {
  const [hasNotes, setHasNotes] = useState(false)
  const [hasRecs, setHasRecs] = useState(false)

  return (
    // Add space above, but less than before so we can split the difference
    <div className='mb-10 mt-5'>
      {/* This empty div creates space and holds the divider in the middle */}
      <div className='relative' style={{ height: '20px' }}>
        {/* Horizontal line exactly in the middle of the space */}
        <div
          className='absolute left-1/2 top-1/2 w-40 -translate-x-1/2 -translate-y-1/2 transform'
          style={{
            height: '0.5px',
            backgroundColor: '#f0f0f0',
          }}
        ></div>
      </div>

      {/* Content starts after the spacer */}
      <div className='mb-4 mt-5'>
        {/* Recommendations component - first */}
        <MediaRecommendations mediaType={mediaType} mediaId={mediaId} onLoad={setHasRecs} />

        {/* Note component - second */}
        <MediaNote mediaType={mediaType} mediaId={mediaId} onLoad={setHasNotes} />
      </div>
    </div>
  )
}

export default UserMetadata
